export default __webpack_public_path__ + "static/media/5bbd1fa266bea27f.29a1ab380c03ad42809a36623064a0bd.svg";